import { useMutation } from '@apollo/client';
import { useMsal } from '@azure/msal-react';
import { useAmplitude } from '@crehana/analytics';
import { useTranslation } from '@crehana/i18n';
import Microsoft from '@crehana/icons/logos/Microsoft';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Tooltip } from '@crehana/ui';
import { useRouter } from 'next/router';

import SOCIAL_LOGIN_MUTATION_V4 from '@/shared/graphql/SocialLoginB2B.v4.authentication.graphql';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import {
  SocialLoginB2B,
  SocialLoginB2BVariables,
} from '@/shared/graphql/types/SocialLoginB2B';

const MicrosoftButton = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const { instance } = useMsal();
  const { logEvent } = useAmplitude();

  const { slug } = router.query as { slug: string };

  const [socialLoginV4] = useMutation<SocialLoginB2B, SocialLoginB2BVariables>(
    SOCIAL_LOGIN_MUTATION_V4,
    { context: { clientName: 'v4.authentication' } },
  );

  const loginV4 = async (variables: SocialLoginB2BVariables) =>
    socialLoginV4({
      variables: {
        token: variables.token,
        backend: variables.backend,
        externalOrganization: variables.externalOrganization,
      },
    });

  const loginWithMS = (id: string) => {
    loginV4({
      token: id,
      backend: 'azuread-oauth2',
      externalOrganization: slug,
    }).then(response => {
      if (response.data?.socialLogin?.response?.type === 'success') {
        logEvent({
          event: 'Successful SignIn',
          data: {
            source: 'Microsoft',
          },
        });
        window.location.href = '/home/';
      }
    });
  };

  const login = () => {
    instance
      .loginPopup({
        scopes: ['openid', 'profile', 'email'],
      })
      .then(response => {
        // biome-ignore lint/style/useBlockStatements: single-line early return
        if (response) loginWithMS(response.idToken);
      });
  };

  return (
    <Tooltip
      label={t('LOGIN_WITH_MICROSOFT_SIGN_IN')}
      position="bottom"
      type="regular"
    >
      <button
        type="button"
        className="flex items-center justify-center w-56 h-48 bg-white rounded-5 shadow-4-dp"
        onClick={() => login()}
      >
        <Microsoft size={28} />
      </button>
    </Tooltip>
  );
};

export default MicrosoftButton;
